const appState = (window.appState = window.appState || {});
const listingManagerState = (window.listingManagerState = window.listingManagerState || {
  'estate_transaction_type': '',
});

$.extend(true, appState, {
  listingManager: (function () {
    var url = '/listing_manager_state/';
    var listingPageUrl = '/aanbieden/adres';

    return function () {
      return {
        init: function () {
          this.refreshSessionState();
          if (typeof ga === 'function') {
            ga('send', {'hitType': 'event', 'eventCategory': 'realtor', 'eventAction': 'realtor_view'});
          }
        },
        getSessionState: function () {
          return listingManagerState;
        },
        updateSessionState: function (key, state, redirect = false) {
          $.ajax({
            method: 'POST',
            url: url,
            data: {
              key: key,
              state: state,
            },
            success: function (result) {
              Object.assign(listingManagerState, result['state']);
              if (redirect) {
                appState.listingManager().redirectToListingPageOrLogin();
              }
            },
            error: function (error) {
              console.log('TRACE: err', error);
            },
          });
        },
        refreshSessionState: function () {
          $.ajax({
            method: 'GET',
            url: url,
            success: function (result) {
              Object.assign(listingManagerState, result['state']);
              let pathname = window.location.pathname;
              var address_url = '/aanbieden/adres/';

              if (pathname.includes(address_url)) {
                var path = window.location.pathname;
                if (path.includes('te_huur')) {
                  appState.listingManager().updateSessionState('estate_transaction_type', 'for_rent');
                } else if (path.includes('te_koop')) {
                  appState.listingManager().updateSessionState('estate_transaction_type', 'for_sale');
                } else {
                  var state = appState.listingManager().getSessionState();
                  if (state['estate_transaction_type'] === 'for_sale') {
                    appState.listingManager().redirectToListingPageOrLogin('te_koop');
                  } else {
                    appState.listingManager().redirectToListingPageOrLogin('te_huur');
                  }
                }
              }
            },
          });
        },
        appendAddressToParams: function () {
          let pathname = window.location.pathname;
          var form_url = 'aanbieden/formulier/';

          if (pathname === form_url) {
            let queryParams = new URLSearchParams(window.location.search);
            let transactionType = listingManagerState['estate_transaction_type'];
            queryParams.set('transaction', transactionType);
            history.replaceState(null, null, '?' + queryParams.toString());
          }
        },
        getSessionStateForKey: function (key) {
          this.refreshSessionState();
          if (Object.keys(listingManagerState).includes(key)) {
            return listingManagerState[key];
          }
          return undefined;
        },
        clearSession: function () {
          $.ajax({
            method: 'DELETE',
            url: url,
          });
        },
        updateForSaleState: function () {
          this.updateSessionState('is_creating', true);
          this.updateSessionState('estate_transaction_type', 'for_sale');
        },
        updateForRentState: function () {
          this.updateSessionState('is_creating', true);
          this.updateSessionState('estate_transaction_type', 'for_rent');
        },
        initForSaleAdvertFlow: function () {
          this.updateForSaleState();
          this.redirectToListingPageOrLogin('te_koop');
        },
        initForRentAdvertFlow: function () {
          this.updateForRentState();
          this.redirectToListingPageOrLogin('te_huur');
        },
        redirectToListingPageOrLogin: function (transaction = undefined) {
          var redirectUrl = `${listingPageUrl}/${transaction}/`;
          if (listingManagerState.user === 'unauthenticated') {
            window.location.href = `inloggen/?next=${redirectUrl}`;
          } else {
            window.location.href = redirectUrl;
          }
        },
      };
    };
  })(),
});

export {appState, listingManagerState};
